<template>
  <div class="app-container">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
      <el-row>
        <el-col :span="8">
          <el-form-item label="分校名称" prop="title">
            <el-input v-model="ruleForm.title"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- <el-form-item label="所属商圈" prop="name">
                <el-select v-model="ruleForm.campus" multiple>
                    <el-option label="a" value="a"></el-option>
                    <el-option label="a" value="b"></el-option>
                    <el-option label="a" value="b"></el-option>
                </el-select>
            </el-form-item> -->
      <el-row>
        <el-col :span="8">
          <el-form-item label="客服电话" prop="phone">
            <el-input v-model="ruleForm.phone"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="8">
          <el-form-item label="分校地址" prop="area">
            <areaSelect
              v-model="ruleForm.area"
              style="width: 95%"
              @province_id="ruleForm.province_id = $event"
              @area_id="ruleForm.area_id = $event"
              @city_id="ruleForm.city_id = $event"
            ></areaSelect>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label-width="0" prop="address">
            <el-input v-model="ruleForm.address"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="分校照片" prop="cover">
        <imgUploads v-model="ruleForm.cover" component-id="img" :limit="8"></imgUploads>
      </el-form-item>
      <el-row>
        <el-col :span="8">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model="ruleForm.mobile"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="账号" prop="account">
            <el-input v-model="ruleForm.account"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="密码" prop="password" :required="!ruleForm.uuid">
            <el-input v-model="ruleForm.password"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button @click="$router.go(-1)">返回</el-button>
      </el-form-item>
    </el-form>

    <!-- <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
          <el-table :data="gridData">
            <el-table-column property="date" label="日期" width="150"></el-table-column>
            <el-table-column property="name" label="姓名" width="200"></el-table-column>
            <el-table-column property="address" label="地址"></el-table-column>
          </el-table>
        </el-dialog> -->
  </div>
</template>

<script>
import areaSelect from "@/components/pub/areaSelect.vue";
import imgUpload from "@/components/pub/imgUploadNormal.vue";
import imgUploads from "@/components/pub/supperUpload.vue";
import { addSchool, schoolDetail, editSchool } from "@/api/school.js";
export default {
  components: {
    imgUpload,
    areaSelect,
    imgUploads,
  },
  data() {
    const phoneRules = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号码"));
      } else {
        const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    const validPassword = (rule, value, callback) => {
      if (!value) {
        callback();
      }
      // const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/
      const reg = /^[A-Za-z0-9]{6,16}$/;
      if (!reg.test(value)) {
        callback(new Error("密码为6-16位数字或字母"));
      } else {
        callback();
      }
    };
    const validAccount = (rule, value, callback) => {
      const reg = /^[A-Za-z0-9]+$/;
      if (!reg.test(value)) {
        callback(new Error("账号支持数字、英文"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        group_id: 928,
      },
      query: {},
      rules: {
        name: [
          {
            required: true,
            message: "请输入负责人名称",
            trigger: "blur",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入分校名称",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入客服电话",
            trigger: "blur",
          },
        ],
        account: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { validator: validAccount, trigger: "blur" },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          { validator: phoneRules, trigger: "blur" },
        ],
        password: [
          // { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validPassword, trigger: "blur" },
        ],
        cover: [
          {
            required: true,
            message: "请上传图片",
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: "请填写详细地址",
            trigger: "blur",
          },
        ],
        area: [
          {
            required: true,
            message: "请选择位置",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    const uuid = this.$route.query.uuid;
    this.query = this.$route.query;
    if (uuid) {
      this.getDetail(uuid);
    }
  },
  methods: {
    async getDetail(uuid) {
      const res = await schoolDetail(uuid);
      console.log(res);
      if (res) {
        this.ruleForm = res;
        this.ruleForm.account = res.admin ? res.admin.account : "";
        this.ruleForm.group_id = res.admin ? res.admin.group_id : "";
        this.ruleForm.area = [res.province_id, res.area_id, res.city_id];
      }
    },
    subEdit() {
      editSchool(this.ruleForm, this.query.uuid).then((res) => {
        if (res) {
          this.$message.success("成功");
          this.$router.go(-1);
        }
      });
    },
    subAdd() {
      addSchool(this.ruleForm).then((res) => {
        if (res) {
          this.$message.success("成功");
          this.$router.go(-1);
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.query.uuid) {
            this.subEdit();
          } else {
            this.subAdd();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style></style>
